import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as contexts from '../../contexts'
import type { TypeParams } from '../types'

/**
 * Applies filters to the Users entity collection whenever the context
 * of the currently selected entity changes. This ensures the list of users
 * is scoped to the selected entity context.
 */
export const setFilters = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    usersEc: ec.Collection<TypeParams>,
    contexts: contexts.Feature,
  ) =>
    contexts.selectors.activeEntityContext.asObservable.pipe(
      rxjs.debounceTime(500),
      rxjs.map(context =>
        usersEc.plugins.currentListPlugin.appliedParams.actions.setFilters
          .from('setFilters (effect)')
          .create(context),
      ),
    ),
)
